<template> 
  <div class="app-wrapper">
    <Header></Header>
    <main class="main-content">
      <router-view/>
    </main>
    <Footer></Footer>
  </div>

  <ConfirmationModal 
    v-if="isConfirmationModalOpen"
    @close="toggleConfirmationModal(false)"    
  /> 

  <ResetPasswordModal 
    v-if="isResetPassModalOpen"
    @close="toggleResetPassModal(false)"    
  /> 
</template>

<script>
import {
    authMethods,
    authComputed,
    dashboardMethods,
    dashboardComputed,

    modalsComputed,
    modalsMethods
} from "./store/helpers";
import ConfirmationModal from './components/InterestedModal.vue';
import ResetPasswordModal from './components/ResetPasswordModal.vue';
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
export default {
  components: {
    Header,
    Footer, 
    ConfirmationModal,
    ResetPasswordModal
  },
  computed: {
        ...authComputed,
        ...dashboardComputed,
        ...modalsComputed,
    },
    methods:{
        ...authMethods,
        ...dashboardMethods,
        ...modalsMethods,

        openConfirmationModal() {
          this.toggleConfirmationModal(true);
        },

        closeConfirmationModal() {
          this.toggleConfirmationModal(false);
        },


        openResetPassModal() {
          this.toggleResetPassModal(true);
        },

        closeResetPassModal() {
          this.toggleResetPassModal(false);
        },
    },

}
</script>

<style>
 *{
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  scroll-behavior: smooth;
 }

 a{
  text-decoration: none;
 }

 html, body, .app-wrapper {
  height: 100%;
  margin: 0;
  padding: 0;
}

.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;  
}

.main-content {
  flex: 1;  
}

 
.flatpickr-months .flatpickr-month{
    background-color: #ff6f2fd4 !important; 
}

.flatpickr-day.selected{
background: #ff6f2fd4 !important; 
border-color: #ff6f2fd4 !important; 
}

.flatpickr-day.today {
    border-color: #ff6f2fd4 !important;
}

.flatpickr-day.today:hover, .flatpickr-day.today:focus {
    border-color: #ff6f2fd4 !important;
    background: #ff6f2fd4 !important; 
}


.multiselect{
  background-color: #FFFFFF !important;
    border: 1px solid #E0E0E0 !important;
    border-radius: 25px !important;
}
</style>
